import { useState } from 'react';
import { ContentModalContentType } from 'domains/content/types';
import ErrorSnackbar from 'domains/core/components/Snackbars/ErrorSnackbar';
import InfoSnackbar from 'domains/core/components/Snackbars/InfoSnackbar';
import SuccessSnackbar from 'domains/core/components/Snackbars/SuccessSnackbar';
import ConfirmationDialog from 'domains/core/components/ConfirmationDialog';
import { Folder } from 'models/types';
import useArchiveTableItem from 'hooks/useArchiveTableItem';

type Props = {
    activeItem: ContentModalContentType | Folder;
    handleModalClose: () => void;
    isOpen: boolean;
    refetchTableData: () => void;
    resetActiveItem: () => void;
};

const ArchiveTableItemModal = ({ activeItem, handleModalClose, isOpen, refetchTableData, resetActiveItem }: Props) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const { getArchiveItemFunction, isLoading, isSuccess } = useArchiveTableItem({
        activeItem,
        refetchTableData,
        resetActiveItem,
        setErrorMessage,
        setSuccessMessage,
    });

    const handleArchive = () => {
        const archiveItem = getArchiveItemFunction();
        archiveItem();
        handleModalClose();
    };

    const onCancel = () => {
        handleModalClose();
        resetActiveItem();
    };

    const infoMessage = `Archiving "${activeItem?.name}"`;
    const contentText = `You are about to archive "${activeItem?.name}." This will move the item to the archive list.`;
    const title = `Archive ${activeItem?.type}`;

    return (
        <>
            {errorMessage && <ErrorSnackbar errorMessage={errorMessage} />}
            {isLoading && <InfoSnackbar successMessage={infoMessage} />}
            {isSuccess && <SuccessSnackbar successMessage={successMessage} />}
            <ConfirmationDialog
                dialogProps={{
                    confirmButtonText: 'Archive',
                    contentText,
                    title,
                }}
                onCancel={onCancel}
                onConfirm={handleArchive}
                onModalClose={handleModalClose}
                open={isOpen}
            />
        </>
    );
};

export default ArchiveTableItemModal;
